export default "/images/img_9.png?e409c42fd70f05f574be193a4d086006";